import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { equalSectionIdsOnPageLoad } from '../Containers/withAnchorNav';
import { isMediumViewport } from '../Hooks/useMedia';

const ToggleChapter = (props) => {
  const [isOpen, setIsOpen] = useState(
    !isMediumViewport()
      ? true
      : equalSectionIdsOnPageLoad(props.AnchorSectionId)
  );

  useEffect(() => {
    if (!equalSectionIdsOnPageLoad(props.AnchorSectionId)) return;
    const element = document.getElementById(props.AnchorSectionId);
    if (!element) return;
    const elementTop = element.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: elementTop, behavior: 'smooth' });
  }, [props.AnchorSectionId]);

  return (
    <div
      className="toggle-chapter"
      id={props.isChapterContainer ? props.AnchorSectionId : undefined}
    >
      {isMediumViewport() ? (
        <details
          open={isOpen}
          onToggle={(e) => setIsOpen(e.target.open)}
          id={props.id}
        >
          <summary className="toggle-chapter__button" aria-expanded={isOpen}>
            <h2 className="toggle-chapter__heading">{props.Heading}</h2>
            <i
              className={classNames({
                'chevron--toggle-chapter': true,
                'chevron--toggle-chapter--is-open': isOpen,
              })}
            />
          </summary>
          {props.children}
        </details>
      ) : (
        props.children
      )}
    </div>
  );
};

export default ToggleChapter;
